@if (showCheckbox) {
    <form [formGroup]="notesForm">
        <mat-divider class="mt-4 mb-4"></mat-divider>
        <mat-checkbox formControlName="notes" class="notes-text" color="primary">
            {{ notesText }}
        </mat-checkbox>
        @if (showError && notesForm.invalid && notesForm.touched) {
            <mat-error> <app-lib-app-field-error [field]="'notes'" [messageList]="formError['notes']" /> </mat-error>
        }
    </form>
} @else {
    <div class="notes-text">{{ notesText }}</div>
}
